import { createServerOnlyFn } from "@tanstack/react-start";
import { getContactVerificationStatus as readVerificationStatus } from "./contact-verification-composition.server";

export const getContactVerificationStatus = createServerOnlyFn(
    (input: { params: { challengeId: string }; request: Request }) =>
        readVerificationStatus(input),
);

export const contactVerificationStatusRoute = {
    server: { handlers: { GET: getContactVerificationStatus } },
};
